import React, { useState } from "react";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getAssetAudits } from "../../api/asset";
import { handleAxiosError } from "../../config/action-config";
import { employeeDocumentTable as tableDef } from "../../config/grid-columns-defs";
import BetterControlledTable from "../../component/BetterControlledTable";
import {
  deleteEmployeeDocument,
  getEmployeeDocumentsById,
  getPdfViewer,
} from "../../api/employee";
import DeleteIcon from "@mui/icons-material/Delete";
import { showAlert } from "../../actions/alert";

export default function EmployeeDocuments({
  id,
  refreshCount,
  documentTypes,
  setRefreshCount,
  handleDelete,
}) {
  console.log("document type--", documentTypes);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const addDocumentColumnIfNeeded = () => {
    let obj = tableDef.find((o) => o.headerName === "Document");
    if (obj === undefined) {
      tableDef.push({
        headerName: "Document",
        field: "file_name",
        resizable: true,
        minWidth: 180,
        cellRenderer: (params) => {
          const handleCellClick = async () => {
            setLoading(true); // Enable loading state before starting the action
            await getDocDownloadData(params.data.id);
          };

          return (
            <a href="#" onClick={handleCellClick}>
              {params.value}
            </a>
          );
        },
      });
    }
  };

  if (!tableDef.some((column) => column.field === "delete")) {
    tableDef.unshift({
      headerName: "",
      field: "delete",
      width: 50,
      cellRenderer: (params) => (
        <DeleteIcon
          // style={{ cursor: "pointer" }}
          onClick={() => {
            handleDelete(params.data.id);
          }}
        />
      ),
    });
  }

  addDocumentColumnIfNeeded();

  const getDocDownloadData = async ({id}) => {
    if (loading) {
      return;
    }
 console.log(id,"id")
    setLoading(true);

    try {
      const token = user.token;
      const blob = await getPdfViewer(id, token);
      const file = window.URL.createObjectURL(blob.data);
      setLoading(false);
      window.open(file, "_blank");
    } catch (err) {
      setLoading(false);
      handleAxiosError(err, dispatch);
    }
  };

  async function getEmployeeDocumentsData(limit, offset) {
    try {
      const { data } = await getEmployeeDocumentsById(user.roleId, user.token, {
        limit,
        offset,
        document_type: documentTypes,
      });
      return {
        rows: data.data.employee_docs,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  return (
    <Box className="pmt-container-box">
      <div className="pmt-controll-table ">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getEmployeeDocumentsData}
          columns={tableDef}
          perPage={10}
          refreshCounter={refreshCount}
        />
      </div>
    </Box>
  );
}
